module.exports = __webpack_public_path__ + "porownanie0.png?d4ba6cc781029680aa2096ea052d4882";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/porownanie0.png
// module id = 7
// module chunks = 0